const GET_BRAND = "GET_BRAND";
const GET_BRAND_SUCCESS = "LIST_BRAND_SUCCESS";
const GET_BRAND_FAILURE = "LIST_BRAND_FAILURE";

export { GET_BRAND, GET_BRAND_SUCCESS, GET_BRAND_FAILURE };
